import { render, staticRenderFns } from "./AdditionalServices.vue?vue&type=template&id=8d2f9840&scoped=true&"
import script from "./AdditionalServices.vue?vue&type=script&lang=js&"
export * from "./AdditionalServices.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalServices.vue?vue&type=style&index=0&id=8d2f9840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2f9840",
  null
  
)

export default component.exports